/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSessionPhase } from './oralExamSessionPhase';
import type { OralExamAggregateCohortStateResponseInExamEnteredAt } from './oralExamAggregateCohortStateResponseInExamEnteredAt';
import type { OralExamAggregateCohortStateResponseActiveDropInBookingId } from './oralExamAggregateCohortStateResponseActiveDropInBookingId';
import type { OralExamAggregateCohortStateResponseSupervisorBroadcast } from './oralExamAggregateCohortStateResponseSupervisorBroadcast';
import type { OralExamBookingRunSummary } from './oralExamBookingRunSummary';
import type { OralExamAggregateCohortStateResponseStageGate } from './oralExamAggregateCohortStateResponseStageGate';
import type { OralExamAggregateCohortStateResponseEtag } from './oralExamAggregateCohortStateResponseEtag';

/**
 * Cohort state with N per-booking run summaries for lecturer polling.
 */
export interface OralExamAggregateCohortStateResponse {
  sessionPhase: OralExamSessionPhase;
  capacity?: number;
  inExamEnteredAt?: OralExamAggregateCohortStateResponseInExamEnteredAt;
  admittedBookingIds?: string[];
  activeDropInBookingId?: OralExamAggregateCohortStateResponseActiveDropInBookingId;
  supervisorBroadcast?: OralExamAggregateCohortStateResponseSupervisorBroadcast;
  bookingRuns?: OralExamBookingRunSummary[];
  stageGate?: OralExamAggregateCohortStateResponseStageGate;
  etag?: OralExamAggregateCohortStateResponseEtag;
}
